import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import './SubmissionForm.css';

const ContactUs = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const initialFormState = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    inquiryType: 'General',
    serviceInterest: '',
    message: '',
  };
  const [formData, setFormData] = useState(initialFormState);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const endpoint = process.env.REACT_APP_FORM_ENDPOINT;
      if (!endpoint) {
        setError('Form is not configured. Set REACT_APP_FORM_ENDPOINT to your form API URL.');
        return;
      }
      await axios.post(
        endpoint,
        { ...formData, category: 'Contact Us' },
        { headers: { Accept: 'application/json' } }
      );
      setSubmitted(true);
      setFormData(initialFormState);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <div className="contactus-page">
      <div className="contactus-container">
        <div className="contactus-form-wrapper">
          <h1>Contact Us</h1>
          <p className="contactus-intro">Get in touch about open positions, partnerships, or general inquiries. We use this to prepare for an initial call.</p>
          {submitted ? (
            <div className="contactus-success">
              <p>Thank you. We&apos;ll get back to you soon.</p>
              <Link to="/" className="contactus-back">Back to Home</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contactus-form">
              <div className="form-row contactus-form-row">
                <div className="form-field">
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-field">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="you@company.com"
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="+1 (555) 000-0000"
                />
              </div>
              <div className="form-field">
                <label htmlFor="companyName">Company / Business name</label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Your company or brand"
                />
              </div>
              <div className="form-field">
                <label htmlFor="inquiryType">What is this about? *</label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  value={formData.inquiryType}
                  onChange={handleChange}
                  required
                >
                  <option value="General">General inquiry</option>
                  <option value="Careers">Careers</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Investors">Investors</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="serviceInterest">Interested in (optional)</label>
                <select
                  id="serviceInterest"
                  name="serviceInterest"
                  value={formData.serviceInterest}
                  onChange={handleChange}
                >
                  <option value="">Select if relevant</option>
                  <option value="SEO">SEO</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Digital & Virtual Tours">Digital & Virtual Tours</option>
                  <option value="Website">Website</option>
                  <option value="Full marketing">Full marketing</option>
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us what you need so we can prepare for the call."
                  rows={4}
                  required
                />
              </div>
              {error && <p className="contactus-error">{error}</p>}
              <button type="submit" className="submit-button">Submit</button>
            </form>
          )}
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ContactUs;
